import React from "react";

import { config } from "@fortawesome/fontawesome-svg-core";
import { AppProps } from "next/app";
import { CookiesProvider } from "react-cookie";
import { ToastContainer } from "react-toastify";

import WelcomePopup from "@/features/homepage/WelcomePopup";
import { FiltersProvider } from "@/providers/FiltersProvider";
import CookieSettings from "@/shared/components/CookieSettings";
import ToastContainerCloseIconSvg from "@/shared/components/ToastContainerCloseIconSvg";
import ToastContainerIconSvg from "@/shared/components/ToastContainerIconSvg";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "react-toastify/dist/ReactToastify.css";
import "react-tooltip/dist/react-tooltip.css";
import "react-modern-drawer/dist/index.css";
import "react-accessible-accordion/dist/fancy-example.css";
import "@/assets/styles/main.scss";

config.autoAddCss = false;
function App({ Component, pageProps }: AppProps) {

    return (
        <CookiesProvider>
            <FiltersProvider>
                <Component {...pageProps} />
                <ToastContainer
                    hideProgressBar
                    position="bottom-left"
                    closeOnClick={false}
                    newestOnTop={false}
                    rtl={false}
                    icon={() => <ToastContainerIconSvg />}
                    closeButton={(props) => <ToastContainerCloseIconSvg onClick={props.closeToast} />}
                />
                <CookieSettings />
                <WelcomePopup />
            </FiltersProvider>
        </CookiesProvider>
    );
}

export default App;
